(() => {
  const purposes = ['analytics', 'marketing', 'preferences'];
  let apiPromise;

  function getPrivacy() {
    const existing = window.Shopify && window.Shopify.customerPrivacy;
    if (existing && typeof existing.setTrackingConsent === 'function' && typeof existing.currentVisitorConsent === 'function') return Promise.resolve(existing);
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve, reject) => {
      const shopify = window.Shopify;
      if (!shopify || typeof shopify.loadFeatures !== 'function') {
        reject(new Error('privacy_unavailable'));
        return;
      }
      const timeout = setTimeout(() => reject(new Error('privacy_timeout')), 10000);
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        clearTimeout(timeout);
        const api = window.Shopify.customerPrivacy;
        if (error || !api || typeof api.setTrackingConsent !== 'function' || typeof api.currentVisitorConsent !== 'function') {
          reject(new Error('privacy_unavailable'));
        } else {
          resolve(api);
        }
      });
    }).catch((error) => {
      apiPromise = undefined;
      throw error;
    });
    return apiPromise;
  }

  function hasChoice(consent) {
    return purposes.every((purpose) => consent[purpose] === 'yes' || consent[purpose] === 'no');
  }

  function persist(api, consent) {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject(new Error('consent_timeout')), 10000);
      try {
        api.setTrackingConsent(consent, (result) => {
          clearTimeout(timeout);
          if (result && result.error) {
            reject(new Error('consent_failed'));
          } else {
            const stored = api.currentVisitorConsent();
            const matches = purposes.every((purpose) => stored[purpose] === (consent[purpose] ? 'yes' : 'no'));
            if (matches) resolve();
            else reject(new Error('consent_not_saved'));
          }
        });
      } catch (error) {
        clearTimeout(timeout);
        reject(error);
      }
    });
  }

  function initialize(banner) {
    if (banner.dataset.llConsentReady) return;
    banner.dataset.llConsentReady = 'true';
    const choices = banner.querySelector('[data-ll-consent-choices]');
    const inputs = Array.from(banner.querySelectorAll('[data-ll-consent-purpose]'));
    const buttons = Array.from(banner.querySelectorAll('[data-ll-consent-action]'));
    const preferencesButton = banner.querySelector('[data-ll-consent-action="preferences"]');
    const saveButton = banner.querySelector('[data-ll-consent-action="save"]');
    const closeButton = banner.querySelector('[data-ll-consent-action="close"]');
    const errorBox = banner.querySelector('[data-ll-consent-error]');
    const manage = Array.from(document.querySelectorAll('[data-ll-consent-manage]')).find((button) => button.dataset.llConsentManage === banner.id);
    let returnFocus = false;
    let hasSavedChoice = false;

    function fill(consent) {
      inputs.forEach((input) => { input.checked = consent[input.dataset.llConsentPurpose] === 'yes'; });
    }

    function hide() {
      banner.hidden = true;
      if (returnFocus && manage) manage.focus();
      returnFocus = false;
    }

    function showPreferences() {
      choices.hidden = false;
      saveButton.hidden = false;
      preferencesButton.setAttribute('aria-expanded', 'true');
      if (inputs[0]) inputs[0].focus();
    }

    function busy(value) {
      banner.setAttribute('aria-busy', value ? 'true' : 'false');
      buttons.forEach((button) => { button.disabled = value; });
      inputs.forEach((input) => { input.disabled = value; });
    }

    buttons.forEach((button) => {
      button.addEventListener('click', async (event) => {
        const action = event.currentTarget.dataset.llConsentAction;
        if (action === 'preferences') {
          showPreferences();
          return;
        }
        if (action === 'close') {
          hide();
          return;
        }
        const consent = {};
        purposes.forEach((purpose) => {
          const input = inputs.find((field) => field.dataset.llConsentPurpose === purpose);
          consent[purpose] = action === 'accept' || (action === 'save' && !!input.checked);
        });
        errorBox.hidden = true;
        busy(true);
        try {
          const api = await getPrivacy();
          await persist(api, consent);
          fill(api.currentVisitorConsent());
          hasSavedChoice = true;
          closeButton.hidden = false;
          hide();
        } catch (error) {
          errorBox.textContent = banner.dataset.errorMessage;
          errorBox.hidden = false;
        } finally {
          busy(false);
        }
      });
    });

    if (manage) {
      manage.addEventListener('click', async () => {
        returnFocus = true;
        banner.hidden = false;
        errorBox.hidden = true;
        closeButton.hidden = !hasSavedChoice;
        showPreferences();
        try {
          const api = await getPrivacy();
          const consent = api.currentVisitorConsent();
          hasSavedChoice = hasChoice(consent);
          closeButton.hidden = !hasSavedChoice;
          fill(consent);
        } catch (error) {
          errorBox.textContent = banner.dataset.errorMessage;
          errorBox.hidden = false;
        }
      });
    }

    getPrivacy().then((api) => {
      const consent = api.currentVisitorConsent();
      fill(consent);
      hasSavedChoice = hasChoice(consent);
      closeButton.hidden = !hasSavedChoice;
      banner.hidden = hasSavedChoice && !returnFocus;
    }).catch(() => {
      banner.hidden = false;
    });
  }

  function boot() {
    document.querySelectorAll('[data-ll-consent-banner]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
